<template>
  <div class="party-list-page">
    <!-- 页面内部 Banner -->
    <section class="page-banner party-banner">
      <!-- 数量为1时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="banner-single-bg">
        <img :src="bannerSlides[0].carouselUrl" class="bg-img">
      </div>

      <!-- 数量大于1时，显示轮播幻灯片 -->
      <div v-else-if="bannerSlides.length > 1" class="banner-slider-bg">
        <div v-for="(slide, idx) in bannerSlides" :key="idx" class="bg-slide" :class="{ active: currentBanner === idx }">
          <img :src="slide.carouselUrl" class="bg-img">
        </div>
      </div>

      <div class="container">
        <h1>企业党建</h1>
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/party', query: { id: pcode } }">企业党建</el-breadcrumb-item>
          <el-breadcrumb-item>党建资讯</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </section>

    <!-- 党建导航 -->
    <section class="news-nav">
      <div class="container">
        <div class="news-tabs">
          <a 
            v-for="(menu, index) in menuList" 
            :key="menu.id"
            href="#" 
            class="tab-item" 
            :class="{ active: activeTab === menu.id || (index === 0 && !activeTab) }"
            @click.prevent="activeTab = menu.id"
          >
            <i :class="getMenuIcon(menu.name)"></i> {{ menu.name }}
          </a>
        </div>
      </div>
    </section>

    <!-- 资讯列表与侧边栏 -->
    <section class="news-list-section">
      <div class="container news-layout">
        
        <!-- 左侧主内容区 -->
        <div class="news-main">
          
          <div class="tab-content">
            <div class="news-items-list">
              <!-- 新闻卡片循环 -->
              <article v-for="(item, index) in newsList" :key="index" class="news-card">
                <router-link :title="item.title" v-if="currentMenu && currentMenu.contenttpl !== 'sys_content_type_news_06' && currentMenu.contenttpl !== 'sys_content_type_news_07'" :to="{ path: '/news/detail', query: { id: item.id, from: 'party', keyword: searchKeyword || '' } }" target="_blank" class="news-thumb">
                  <div class="placeholder-img">
                    <img
                      :src="item.ico"
                      style="width: 100%; height: 100%; object-fit: cover;"
                      :defaultimg="currentMenu && currentMenu.defaultImg">
                      <span class="new-top" v-if="item.istop === '1' || item.istop === 1">
                        <i class="el-icon-top" style="margin-right:2px; font-size: 14px;"></i>Top
                      </span>
                  </div>
                </router-link>
                <div class="news-body">
                  <h4>
                    <router-link :title="item.title" :to="{ path: '/news/detail', query: { id: item.id, from: 'party', keyword: searchKeyword || '' } }" target="_blank" :style="{color: item.titlecolor != '' ? item.titlecolor:'#333333'}">
                      {{ item.title }}
                       <span v-if="item.isrecommend == 1" class="tag tag-recommend"><i class="el-icon-star-on" style="margin-right:2px; font-size: 0.8rem;"></i>推荐</span>
                    </router-link>
                  </h4>
                  <p class="news-summary">{{ item.description }}</p>
                  <div class="news-meta">
                    <span><i class="el-icon-date"></i> {{ item.date }}</span>
                    <span v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ item.visits }}</span>
                     <span v-if="item.statusLabel && item.statusLabel !== ''" class="status-label"
                      :style="{ color: item.statusColor || '#1e3a5f', backgroundColor: (item.statusColor || '#1e3a5f') + '20' }">
                      {{ item.statusLabel }}
                    </span>
                  </div>
                </div>
              </article>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper" v-if="newsList.length > 0">
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :total="total"
                :current-page="pageNum"
                :page-size="pageSize"
                :pager-count="3"
                @current-change="handlePageChange"
              >
              </el-pagination>
            </div>
            
            <!-- 暂无数据 -->
            <div v-if="newsList.length === 0" class="empty-state">
              <el-empty description="暂无资讯数据"></el-empty>
            </div>
          </div>

        </div>

        <!-- 右侧边栏 -->
        <aside class="news-sidebar">
          <!-- 搜索框 -->
          <div class="sidebar-widget">
            <h4>党建搜索</h4>
            <div class="sidebar-search">
              <input type="text" placeholder="输入关键词搜索..." v-model="searchKeyword" @keyup.enter="doSearch">
              <button @click="doSearch"><i class="el-icon-search"></i></button>
            </div>
          </div>

          <!-- 热门资讯 -->
          <div class="sidebar-widget">
            <h4><i class="el-icon-s-data" style="color:#c0392b; margin-right:5px;"></i> 热门动态</h4>
            <ul class="recommend-list">
              <li v-for="(hot, i) in hotNewsList" :key="i">
                <router-link :title="hot.title" :to="{ path: '/news/detail', query: { id: hot.id, from: 'party', keyword: searchKeyword || '' } }" target="_blank" :style="{color: hot.titlecolor != '' ? hot.titlecolor:'#333333'}">
                  <span class="num" :class="{ top3: i < 3 }">{{ i + 1 }}</span>
                  <span class="title">{{ hot.title }}</span>
                  <span class="views" v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ hot.visits }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </aside>

      </div>
    </section>
  </div>
</template>

<script>
import { getSubMenuList, getNewsSolrList, getHotNews, getBannerList } from '@/api/menu'

export default {
  name: 'PartyList',
  data() {
    return {
      bannerSlides: [],
      currentBanner: 0,
      bannerTimer: null,
      activeTab: null,
      menuList: [],
      pcode: this.$route.query.id, 
      searchKeyword: '',
      newsList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      currentMenu: null,
      hotNewsList: []
    }
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.pcode = newId;
          this.fetchSubMenus();
        }
      },
      immediate: false
    },
    activeTab: {
      handler(newTab) {
        if (newTab) {
          this.pageNum = 1;
          this.currentMenu = this.menuList.find(m => m.id === newTab);
          this.fetchNewsList();
          this.fetchHotNews();
        }
      }
    }
  },
  created() {
    this.fetchBanner("qydj");
    this.fetchSubMenus();
  },
  mounted() {
    this.startBannerTimer();
  },
  beforeDestroy() {
    if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
    }
  },
  methods: {
    getMenuIcon(name) {
      if (!name) return 'el-icon-s-flag';
      if (name.includes('概况')) return 'el-icon-s-flag';
      if (name.includes('动态')) return 'el-icon-document';
      if (name.includes('专题')) return 'el-icon-collection-tag';
      if (name.includes('党规')) return 'el-icon-connection';
      if (name.includes('廉洁')) return 'el-icon-circle-check';
      return 'el-icon-s-flag';
    },
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length;
        }
      }, 4000);
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode })
        if (res.code === 0) {
          this.bannerSlides = res.rows || []
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    async fetchSubMenus() {
      try {
        const res = await getSubMenuList(this.pcode, "sys_content_type_news")
        if (res.code === 0 || res.code === 200) {
          this.menuList = res.rows || []
          if (this.menuList.length > 0) {
            // 支持从query加载指定页签
            if (this.$route.query.tab) {
                const found = this.menuList.find(m => m.contenttpl === this.$route.query.tab);
                if (found) {
                    this.activeTab = found.id;
                    return;
                }
            }
            this.activeTab = this.menuList[0].id
          }
        }
      } catch (error) {
        console.error('获取党建二级菜单失败', error)
      }
    },
    async fetchNewsList() {
      if (!this.currentMenu || !this.currentMenu.contenttpl) {
        this.newsList = []
        this.total = 0
        return
      }
      try {
        const res = await getNewsSolrList({
          info_type: this.currentMenu.contenttpl,
          keyword: this.searchKeyword,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        if (res.code === 0 || res.code === 200) {
          this.newsList = res.rows || []
          this.total = res.total || 0
        }
      } catch (error) {
        console.error('获取文章列表失败', error)
      }
    },
    async fetchHotNews() {
      if (!this.currentMenu || !this.currentMenu.contenttpl) return
      try {
        const res = await getHotNews({
          info_type: this.currentMenu.contenttpl,
          limit: 5
        })
        if (res.code === 0 || res.code === 200) {
          this.hotNewsList = res.rows || []
        }
      } catch (error) {
        console.error('获取热门资讯失败', error)
      }
    },
    handlePageChange(page) {
      this.pageNum = page
      this.fetchNewsList()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    doSearch() {
      this.pageNum = 1;
      this.fetchNewsList();
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-red: #c0392b;
$hover-red: #a93226;
$primary-blue: #1a3a5c;
$light-bg: #ffffff;
$border: #e8edf3;
$text-main: #333;
$text-secondary: #666;
$text-light: #999;

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ---- Banner 头图 ---- */
.page-banner {
  background-size: cover;
  background-color: $primary-red;
  color: #fff;
  padding: 60px 0;
  position: relative;

  .banner-single-bg, .banner-slider-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .bg-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.8s ease;
    &.active { opacity: 1; }
  }

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h1 {
    font-size: 2.2rem;
    font-weight: 600;
    margin: 0 0 15px 0;
    letter-spacing: 2px;
  }
  
  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__separator {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #fff !important;
  }
}

/* ---- 资讯导航 ---- */
.news-nav {
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);

  .news-tabs {
    display: flex;
    gap: 12px;
    padding: 15px 0;
    overflow-x: auto;
    
    &::-webkit-scrollbar { display: none; }

    .tab-item {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 10px 20px;
      font-size: 0.95rem;
      color: #333333;
      background-color: #f4f7fa;
      border-radius: 4px;
      text-decoration: none;
      font-weight: 500;
      white-space: nowrap;
      transition: all 0.2s ease;

      i { 
        font-size: 1.1rem; 
        color: #606266; 
        transition: color 0.2s; 
      }

      &:hover {
        background-color: #e2e8f0;
        color: $primary-red;
        i { color: $primary-red; }
      }

      &.active {
        background-color: $primary-red;
        color: #ffffff;
        font-weight: 600;

        i { color: #ffffff; }
      }
    }
  }
}

/* ---- 列表区域与侧边栏布局 ---- */
.news-list-section {
  padding: 40px 0;
  background: $light-bg;
}

.news-layout {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.news-main {
  flex: 1;
  min-width: 0;
}

.news-sidebar {
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

/* ---- 列表项 ---- */
.news-items-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.news-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  gap: 20px;
  border: 1px solid transparent;
  transition: all 0.3s;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);

  &:hover {
    box-shadow: 0 8px 24px rgba(0,0,0,0.08);
    border-color: rgba($primary-red, 0.1);
    transform: translateY(-2px);
  }

  .news-thumb {
    width: 200px;
    height: 130px;
    flex-shrink: 0;
    border-radius: 6px;
    overflow: hidden;

    .placeholder-img {
      width: 100%; height: 100%;
      position: relative;
      background: #e9ecef;
      display: flex; align-items: center; justify-content: center;
      i { font-size: 3rem; color: #ced4da; }
      .new-top {
        position: absolute;
        top: 5px;
        left: 5px;
        color: #dbb523;
        border: none;
        font-weight: 700;
        display: inline-flex;
        align-items: center;
        border-radius: 4px;
        font-size: 0.8rem;
        z-index: 2;
        .el-icon-top {
          color: #dbb523 !important;
        }
      }
    }
  }

  .news-body {
    flex: 1;
    display: flex;
    flex-direction: column;

    h4 {
      margin: 0 0 10px 0;
      font-size: 18px;
      line-height: 1.4;

      a {
        color: $text-main;
        text-decoration: none;
        transition: color 0.2s;
        &:hover { color: $primary-red; }
      }
    }

    .news-summary {
      font-size: 13px;
      color: $text-secondary;
      line-height: 1.6;
      margin: 0 0 14px 0;
      flex: 1;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .news-meta {
      display: flex;
      gap: 20px;
      font-size: 0.85rem;
      color: $text-light;

      span {
        display: flex;
        align-items: center;
        gap: 5px;
      }
      .status-label {
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 12px;
        margin-left: 8px;
        vertical-align: middle;
        font-weight: normal;
      }
    }

    .tag {
        display: inline-block;
        font-size: 0.75rem;
        padding: 2px 8px;
        border-radius: 12px;
        margin-left: 8px;
        vertical-align: middle;
        font-weight: normal;

        &.tag-urgent { background: #ffeaea; color: #c0392b; border: 1px solid #ffcccc; }
        &.tag-end { background: #f0f2f5; color: #909399; border: 1px solid #dcdfe6; }
        &.tag-notice { background: #e6f7ff; color: #1890ff; border: 1px solid #91d5ff; }
        &.tag-promo { background: #fff7e6; color: #fa8c16; border: 1px solid #ffd591; }
        &.tag-recommend {
          background: linear-gradient(135deg, #ffaa00 0%, #e4393c 100%);
          color: #fff;
          border: none;
          font-weight: 600;
          padding: 2px 7px;
          display: inline-flex;
          align-items: center;
          box-shadow: 0 2px 5px rgba(228, 57, 60, 0.25);
        }
      }
  }
}

/* 分页 */
.pagination-wrapper {
  margin-top: 30px;
  background: #fff;
  padding: 15px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
  flex-wrap: wrap;
}
::v-deep {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #1e3a5f !important;
  }
}
.empty-state {
  background: #fff;
  padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}

/* ---- 侧边栏小部件 ---- */
.sidebar-widget {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);

  h4 {
    margin: 0 0 15px 0;
    font-size: 1.1rem;
    color: $primary-red; // 侧栏标题为党建红
    border-bottom: 2px solid $border;
    padding-bottom: 10px;
  }
}

$search-input-bg: transparent;

/* 搜索框 */
.sidebar-search {
  display: flex;
  border: 1px solid $border;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;

  input {
    flex: 1;
    border: none;
    padding: 10px 12px;
    outline: none;
    background: $search-input-bg;
    font-size: 0.9rem;
    width: 0;
    min-width: 0;
  }

  button {
    background: $primary-red;
    color: #fff;
    border: none;
    padding: 0 15px;
    cursor: pointer;
    transition: background 0.2s;
    flex-shrink: 0;
    &:hover { background: $hover-red; }
  }
}

/* 热门资讯 */
.recommend-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  li {
    margin-bottom: 12px;
    width: 100%;
    box-sizing: border-box;
    &:last-child { margin-bottom: 0; }

    a {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      text-decoration: none;
      color: $text-main;
      transition: color 0.2s;
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      
      &:hover { color: $primary-red; }

      .num {
        background: #f0f2f5;
        color: #909399;
        font-size: 0.8rem;
        min-width: 20px;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        margin-top: 2px;
        font-weight: bold;
        flex-shrink: 0;

        &.top3 {
          background: #fff1f0;
          color: #f5222d;
        }
      }

      .title {
        flex: 1;
        font-size: 13px;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
        max-width: calc(100% - 70px); /* 预留数字和浏览量的空间 */
        word-break: break-all;
      }

      .views {
        font-size: 0.8rem;
        color: $text-light;
        white-space: nowrap;
        margin-top: 2px;
        flex-shrink: 0;
      }
    }
  }
}

/* ================= 响应式 ================= */
@media (max-width: 1024px) {
  .news-layout { flex-direction: column; }
  .news-sidebar { width: 100%; display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
}

@media (max-width: 1000px) {
  .page-banner { padding: 30px 0; h1 { font-size: 1.6rem; } }
  .news-nav .news-tabs {
    overflow-x: hidden; /* 去除滚动条 */
    flex-wrap: wrap; /* 允许换行 */
    justify-content: flex-start;
  }
  .news-nav .news-tabs .tab-item { padding: 10px 15px; font-size: 0.9rem; }
  .news-sidebar { 
    grid-template-columns: 1fr; 
    width: 100%;
    box-sizing: border-box; /* 确保宽度计算正确 */
  }
  .sidebar-widget {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden; /* 防止内容溢出 */
  }
  .recommend-list li a {
    .title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: calc(100% - 80px); /* 确保标题不溢出 */
    }
  }
  .news-card {
    flex-direction: column;
    padding: 15px; gap: 15px;
    .news-thumb { width: 100%; height: 180px; }
  }
  .sidebar-search button { padding: 10px 20px; } /* 增大触摸区域 */
}
</style>
